import { BaseDto } from "src/dtos/common/baseDto";

/** 근속수당 엔티티 필드와 그리드 편집 상태이다. */
export interface HrmServiceAllowDto extends BaseDto {
    startDt: string; // 적용시작일
    fromYear: number; // 근속 이상 년수
    toYear: number; // 근속 미만 년수
    allowAmt: number; // 수당 월액
    endDt: string; // 적용종료일
    useYn: string; // 사용여부
    remark: string | null; // 비고
    inserted: boolean; // true이면 서버에 저장하지 않은 신규 행
    isModified: boolean; // true이면 조회 후 편집한 행
}

/** 새 기준 행의 전체 기본값이다. 감사 정보는 서버가 설정한다. */
export const defaultHrmServiceAllowDto: HrmServiceAllowDto = {
    valueIndex: 0, orderIndex: 0, orderIndexSeq: 0,
    startDt: '',
    fromYear: 0,
    toYear: 0,
    allowAmt: 0,
    endDt: '9999-12-31',
    useYn: 'Y',
    remark: '',
    inserted: false, isModified: false,
};
